import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-white" data-id="element-18">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-19">
        <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-8 tracking-tight" data-id="element-20">
          Commencez votre parcours en Taekwondo dès aujourd'hui
        </h2>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-21">
          <a href="tel:450-638-6584" className="w-full sm:w-auto px-8 py-4 bg-red-600 text-white font-bold rounded-full hover:bg-red-700 transition-colors duration-300 shadow-lg shadow-red-600/20 flex items-center justify-center group" data-id="element-22">
            Réserver un cours d'essai gratuit
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-23" />
          </a>
        </div>
      </div>
    </section>;
}